<script setup lang="ts">
import { useSiteStore } from '~/stores/site'
/** قالب فعال را داینامیک رندر می‌کند. */
const props = defineProps<{ view: 'landing' | 'detail' }>()
const site = useSiteStore()
const component = computed(() =>
  props.view === 'landing' ? site.current.landing : site.current.detail
)
</script>

<template>
  <component :is="component" v-bind="$attrs" />
</template>
